module.exports = __webpack_public_path__ + "img/407.9a9d7046.png";